import { API_BASE_URL } from '../globals';
import { POST } from '@api/apiHandler';
import { CLI_CODE } from './routes';

interface RequestCliCodeArgs {
  cli_name: string;
  device_hint?: string;
  code_challenge: string;
}

export const requestCliCode = async (args: RequestCliCodeArgs) => {
  return POST(`${API_BASE_URL}${CLI_CODE}`, args);
};
